// extracted by mini-css-extract-plugin
export default {"gridContainer":"ContactsGrid_gridContainer__cofDR","gridOverlay":"ContactsGrid_gridOverlay__VmPHb"};